export default __webpack_public_path__ + "static/media/glovevideo.a2fab8bc.mp4";